// Scroll to top when changing routes so that the user doesn’t end up halfway
// the page after navigating.
export default /* @ngInject */ function scrollTopOnRouteChange($rootScope, $anchorScroll) {
    $rootScope.$on('$routeChangeStart', () => $anchorScroll());
}



// WEBPACK FOOTER //
// ./config/route-scroll-top.js